var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIconCashBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yjrHLhUhkSUwa9I7EjbBUa",
    x1: 9.875,
    x2: 38.159,
    y1: -6.125,
    y2: 22.159,
    gradientTransform: "translate(0 16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yjrHLhUhkSUwa9I7EjbBUa)",
    d: "M44,24c0,11-9,20-20,20S4,35,4,24S13,4,24,4S44,13,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.3,28.7c0-7.2-10.6-5.8-10.6-10c0-2.2,2.5-2.3,3.3-2.3c1.9,0,3.7,0.5,5.1,1.1c0.4,0.2,0.9-0.1,0.9-0.6v-2.1 c0-0.7-0.3-1.1-0.7-1.3c-0.9-0.4-2.3-0.6-4.3-0.7v-2.3c0-0.3-0.2-0.5-0.5-0.5h-1c-0.3,0-0.5,0.2-0.5,0.5v2.3 c-3.1,0.3-6.3,2.1-6.3,6.2c0,7.5,10.6,6,10.6,9.9c0,1.2-0.8,2.3-3.3,2.3s-4.8-0.9-6.1-1.5c-0.4-0.2-0.9,0.1-0.9,0.6v2.4 c0,0.5,0.3,0.9,0.7,1c1.5,0.6,3.5,1.1,5.3,1.3v2.5c0,0.3,0.2,0.5,0.5,0.5h1c0.3,0,0.5-0.2,0.5-0.5V35C29.7,34.6,31.3,31.4,31.3,28.7 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIconCashBonus);
export default __webpack_public_path__ + "static/media/dollar-icon-cash-bonus.975402c1d44bab0c6f3a3ec22be82f51.svg";
export { ForwardRef as ReactComponent };